import { render } from "./TheTrinhDoChuyenMonCoSoDuoc.vue?vue&type=template&id=0c92b0ae"
import script from "./TheTrinhDoChuyenMonCoSoDuoc.vue?vue&type=script&lang=js"
export * from "./TheTrinhDoChuyenMonCoSoDuoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__